import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModalModule } from '@app/core/user/containers/auth-modal/auth-modal.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { UserEffects } from './store/effects/user.effects';
import { reducers } from './store/reducers';

@NgModule({
  imports: [
    CommonModule,
    AuthModalModule,
    StoreModule.forFeature('auth', reducers),
    EffectsModule.forFeature([UserEffects])
  ],
  exports: [AuthModalModule]
})
export class UserModule {}
